import {h} from 'preact'
import Button from '../ui-components/Button'

export type TypesThatCanBeAdded = 'html_widget'

interface Props {
  onClick: (type: TypesThatCanBeAdded) => void
}

export default ({onClick}: Props) => {
  return <div style={{textAlign: 'center'}}>
    <Button small insided onClick={
      () => onClick('html_widget')
    }>Add a HTML widget</Button>
  </div>
}
